<template>
        <TopBar></TopBar>    
    <header class="masthead text-white text-center w-100 h-100">
        <div class="container d-flex align-items-center flex-column">
            <!-- Masthead Avatar Image-->
             <Background></Background>
            <div class="mb-5" @mouseover="starSpin" @mouseout="stopSpin" @touchstart="starSpin">
                <a href="#services" title="Conoce nuestros servicios">
                    <span class="fa-stack fa-5x fa-spin" id="gearSpin">
                        <i class="fas fa-gear fa-stack-2x text-white"></i>
                        <i class="fas fa-globe fa-sm fa-stack-1x text-info bg-white"></i>
                    </span>
                </a>
            </div>
            <!-- Masthead Heading-->
            <h1 class="masthead-heading text-uppercase mb-4">Systems TecWeb</h1>
            <!-- Icon Divider-->
            <!-- Masthead Subheading-->
            <p class="masthead-subheading font-weight-light mb-1">Desarrollando Soluciones, Optimizando Procesos</p>
            <div class="divider-custom divider-light ">
                <div class="divider-custom-line bg-info"></div>
                <div class="divider-custom-icon"><a href="#portfolio" title="Ver Proyectos" class="text-white"><i
                            class="fas fa-caret-down fa-bounce "></i></a></div>
                <div class="divider-custom-line bg-info"></div>
            </div>
        </div>
    </header>
    <!-- Portfolio Section-->
    <section class="page-section bg-white" id="services">
        <div class="container">
            <div class="text-center mb-1">
                <h2 class="section-heading text-uppercase">Servicios</h2>
                <p class="section-subheading text-muted">Brindamos soluciones tecnológicas para ayudarte alcanzar tus
                    objetivos</p>
            </div>
            <div class="row text-center">
                <div class="col-md-4 h-100">
                    <span class="fa-stack fa-4x ">
                        <i class="fas fa-gear fa-stack-2x text-info"></i>
                        <i class="fas fa-code  pe-1 bg-info fa-stack-1x fa-inverse"></i>
                    </span>
                    <h3 class="my-3">Desarrollo Web</h3>
                    <p class="text-muted">Construimos aplicaciones desde cero que se adaptan perfectamente a tus
                        objetivos y procesos de negocio.</p>
                </div>
                <div class="col-md-4 h-100">
                    <span class="fa-stack fa-4x">
                        <i class="fas fa-gear fa-stack-2x text-info"></i>
                        <i class="fas fa-tasks bg-info fa-stack-1x fa-inverse"></i>
                    </span>
                    <h3 class="my-3">Estrategia de Producto Digital</h3>
                    <p class="text-muted">Ayudamos a crear una hoja de ruta (roadmap) para el desarrollo del producto.
                    </p>
                </div>
                <div class="col-md-4 h-100">
                    <span class="fa-stack fa-4x">
                        <i class="fas fa-gear fa-stack-2x text-info"></i>
                        <i class="fas fa-sitemap pe-1 bg-info fa-stack-1x fa-inverse"></i>
                    </span>
                    <h3 class="my-3">Integración de APIs</h3>
                    <p class="text-muted">Conectamos tu aplicación con otras herramientas esenciales como pasarelas de
                        pago (Stripe, PayPal), sistemas de email marketing, servicios de mapas, etc.</p>
                </div>
            </div>
        </div>
    </section>
    <section class="page-section bg-light portfolio" id="portfolio">
        <div class="container">
            <!-- Portfolio Section Heading-->
            <h2 class="section-heading text-center text-uppercase mb-0">Portafolio de Proyectos</h2>
            <!-- Icon Divider-->
            <div class="divider-custom">
                <div class="divider-custom-line bg-info"></div>
                <RouterLink :to="{name:'SitiosWeb',hash:'#topbar'}" title="Desarrollo de Sitios Web">
                <div class="divider-custom-icon text-info"><i class="fas fa-globe"></i></div>
                </RouterLink>
                <div class="divider-custom-line bg-info"></div>
            </div>
            <div class="row">
            <Proyectos>
                <div class="col-lg-4 col-sm-6 mb-4">
                    <div class="portfolio-item">
                    </div>
                </div>
            </Proyectos></div>
        </div>
    </section>
    <!-- About Section-->
    <section class="page-section bg-info text-white mb-0" id="about">
        <!-- About Section Heading-->
        <h2 class="page-section-heading text-center text-uppercase text-white">Nosotros</h2>
        <!-- Icon Divider-->
        <div class="divider-custom divider-light">
            <div class="divider-custom-line"></div>
            <div class="divider-custom-icon"><i class="fas fa-globe"></i></div>
            <div class="divider-custom-line"></div>
        </div>
        <!-- About Section Content-->
        <div class="row">
            <div class="col-lg-4 ms-auto">
                <p class="lead justify-content">Tenemos experiencia en desarrollo de software, especializados en la
                    creación de soluciones web personalizadas y eficientes. </p>
                <p class="lead">Nos apasiona transformar ideas en realidad digital, utilizando tecnologías modernas
                    para ofrecer productos robustos y escalables. Nuestro enfoque se centra en entender a fondo las
                    necesidades de nuestros clientes para brindar resultados que superen las expectativas.</p>

            </div>
            <div class="col-lg-4 me-auto">
                <p class="lead">Nuestra misión es desarrollar soluciones web que impulsen el crecimiento de nuestros
                    clientes a través de soluciones innovadoras y a medida. Visualizamos un futuro donde la
                    tecnología sea una herramienta accesible y transformadora para negocios de todos los tamaños, y
                    trabajamos para hacer esa visión una realidad.
                </p>
            </div>
        </div>
        <!-- About Section Button-->
        <BtnContact></BtnContact>
    </section>    
    <!-- Contact Section-->
     <Footer></Footer>
</template>
<style scoped>


#gearSpin {
    --fa-animation-duration: 5s;
    --fa-animation-iteration-count: 1;
}

#contact{
    text-shadow: 1px 1px var(--bs-gray-500);
}
</style>
<script setup>
import { ref, onMounted, defineAsyncComponent } from 'vue';
import { RouterLink } from 'vue-router';
import TopBar from '@/views/TopBar.vue'
import Footer from '@/views/Footer.vue'
import BtnContact from '@/components/BtnContact.vue';
import Background from '@/components/Background.vue';

const Proyectos = defineAsyncComponent({
    loader: () => import('../components/Proyectos.vue'),
    delay: 1000 /* delay in ms before showing loading component */,
    timeout: 3000 /* timeout after this many ms */,
});


const starSpin = (e) => {
    e.preventDefault();
    const elSpin = document.body.querySelector('#gearSpin');
    elSpin.classList.add('fa-spin');
}
const stopSpin = (e) => {
    e.preventDefault(e);
    const elSpin = document.body.querySelector('#gearSpin');
    elSpin.classList.remove('fa-spin');
}
</script>